module.exports = __webpack_public_path__ + "static/media/10client.dad46b8e.png";